import { render, staticRenderFns } from "./Seconectcation.vue?vue&type=template&id=19473fb4&scoped=true&"
import script from "./Seconectcation.vue?vue&type=script&lang=js&"
export * from "./Seconectcation.vue?vue&type=script&lang=js&"
import style0 from "./Seconectcation.vue?vue&type=style&index=0&id=19473fb4&scoped=true&lang=css&"
import style1 from "./Seconectcation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19473fb4",
  null
  
)

export default component.exports